import {
  FieldOption,
  LogicalOperator,
  OperatorOption,
  SaleType,
} from '@/components/publicSearch/constants';
import { SALE_FILTER_FIELD } from '@/constants/saleFilters';
import type {
  ComparisonOperator,
  FilterGroupOfSaleFilteredFilterOptionInput,
  SaleFilterField,
} from '@/graphqlClient/types';

export function buildCurrentSaleFilterGroup(
  today: string,
): FilterGroupOfSaleFilteredFilterOptionInput {
  return {
    filters: [
      {
        field: SALE_FILTER_FIELD.PUBLISH_TILL_DATE as SaleFilterField,
        operator: OperatorOption.greaterThanOrEqual.value as ComparisonOperator,
        value: today,
      },
    ],
    groups: [
      {
        // i4 keeps semen and embryo listings current through publication expiry,
        // regardless of their sale date. Apply this per row for mixed-type searches.
        filters: [SaleType.SemenListing, SaleType.EmbryoListing].map(
          (value) => ({
            field: FieldOption.saleType.value as SaleFilterField,
            operator: OperatorOption.equals.value as ComparisonOperator,
            value,
          }),
        ),
        groups: [
          {
            filters: [
              {
                field: FieldOption.saleDate.value as SaleFilterField,
                operator: OperatorOption.isNotEmpty.value as ComparisonOperator,
                value: '',
              },
              {
                field: FieldOption.saleDate.value as SaleFilterField,
                operator: OperatorOption.greaterThanOrEqual
                  .value as ComparisonOperator,
                value: today,
              },
            ],
            logicalOperator: LogicalOperator.and,
          },
        ],
        logicalOperator: LogicalOperator.or,
      },
    ],
    logicalOperator: LogicalOperator.and,
  };
}
